import styles from '../styles/loading-fallback.module.scss';

const LoadingFallback = ({ fallbackMessage }: { fallbackMessage?: string }) => {
    return <p className={styles.fallbackMessage}>{fallbackMessage ?? '読み込み中...'}</p>;
};

export default LoadingFallback;
